class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    // On UK the header search input's type is changed to "text" before this runs (by another script on the page), so there is no
    // input to bind to and the theme's own predictive search stays off — as it always has. Stop here instead of
    // throwing on every page.
    if (!this.input) return;

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

      this.addEventListener('change', this.debounce((event) => {

          this.onChange(event);
    
    }, 300).bind(this));

    let searchTerms = "";
    this.updateDefaultResults(searchTerms);
  }

  updateDefaultResults(searchTerms) {

    let searchUrl = document.querySelector("predictive-search").dataset.firstLinkUrl;
    
    searchUrl = `${searchUrl}&section_id=search-results&${searchTerms}`;
    
    if(searchUrl.includes("/search?q=")) {
    let searchTerm = searchUrl.split("/search?q=")[1];
    
    searchTerm = searchTerm.split("&")[0];
    
    let predictiveSearchUrl = `/search/suggest?q=${searchTerm}&section_id=predictive-search-queries`;
    
    this.updateSearchResultsHtml(searchUrl, predictiveSearchUrl);
    }
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    
    let searchTerms = "";

     const formData = new FormData(this.querySelector("form[action='/search']"));

    let searchParams = new URLSearchParams(formData);

    console.log(searchParams)
    if (!searchTerm.length) {

       searchParams.delete("q");
    searchTerms = searchParams.toString();

      this.updateDefaultResults(searchTerms);
     // this.close();
      return;
    } else {
       searchParams.set("q", searchTerm);
    searchTerms = searchParams.toString();

    }

      this.getMainSearchResults(searchTerm, searchTerms);
    
  }

  updateSearchResultsHtml(searchUrl, predictiveSearchUrl) {
      fetch(searchUrl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;

        let searchFilterLables = this.predictiveSearchResults.querySelectorAll(".facet-filter-label-wrapper.active-heading");
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        
        if(searchFilterLables.length) {
          searchFilterLables.forEach(searchFilterLable => {

            let searchFilterLableId = searchFilterLable.dataset.id;

            this.predictiveSearchResults.querySelector(`.facet-filter-label-wrapper[data-id="${searchFilterLableId}"]`)?.classList.add("active-heading");
            this.predictiveSearchResults.querySelector(`[id="${searchFilterLableId}"]`)?.setAttribute("open", true);
            
          })
        }
        
           fetch(predictiveSearchUrl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-queries').innerHTML;

        if(document.querySelector(".facet-filters-suggestions")) {
          document.querySelector(".facet-filters-suggestions").innerHTML = resultsMarkup;
        }

            this.querySelectorAll(".search-query-link")?.forEach(searchQueryLink => {

      searchQueryLink.addEventListener("click", e => {
        e.preventDefault();

        let currentLink = e.target;

        if(!currentLink.classList.contains("search-query-link")) {

          currentLink = e.target.closest(".search-query-link")
        }

        let searchUrl = currentLink.getAttribute("href");

          searchUrl = `${searchUrl}&section_id=search-results`;

        if(searchUrl.includes("/search?q=")) {
            let searchTerm = searchUrl.split("/search?q=")[1];

          searchTerm = searchTerm.split("&")[0];
          
            let predictiveSearchUrl = `/search/suggest?q=${searchTerm}&section_id=predictive-search-queries`;
            
            this.updateSearchResultsHtml(searchUrl, predictiveSearchUrl);
        }
     
      })
      
    })
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });

      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
    getMainSearchResults(searchTerm, searchTerms) {
      let searchUrl = `/search?${searchTerms}&section_id=search-results`;
      let predictiveSearchUrl = `/search/suggest?q=${searchTerm}&section_id=predictive-search-queries`;
      
      this.updateSearchResultsHtml(searchUrl, predictiveSearchUrl);
      
  }
  
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;


     
        
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);